import { render, staticRenderFns } from "./WidgetColItem.vue?vue&type=template&id=62a2d12c"
import script from "./WidgetColItem.vue?vue&type=script&lang=js"
export * from "./WidgetColItem.vue?vue&type=script&lang=js"
import style0 from "./WidgetColItem.vue?vue&type=style&index=0&id=62a2d12c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports